import React, { useEffect, useRef, useState } from "react";
import Search from "../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Form, Table, Tooltip } from "antd";
import svg27 from "../../../assets/svg/svg27.svg";
import svg12 from "../../../assets/svg/svg12.svg";
import svg15 from "../../../assets/svg/svg15.svg";
import svg49 from "../../../assets/svg/svg49.svg";
import BreadCrumb from "../../../layout/BreadCrumb";
import CardLoading from "../../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import { fetchData } from "../../../features/fetch/fetchSlice";
import { setActiveObj } from "../../../features/obj/objSlice";
import { formatText } from "../../../utils";
import ConfirmModal from "../../../components/ConfirmModal";
import { save } from "../../../features/save/saveSlice";
import toast from "react-hot-toast";
import svg29 from "../../../assets/svg/svg29.svg";
import useModalToggle from "../../../custom_hooks/useModalToggle";
import CropBandView from "./CropBandView";

function CropBandTable({ pathwayId }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const url = "crop_band/fetch_cropbands";

  const { loading, data, count, dataScheme } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));

  const [searchInput, setsearchInput] = useState(null);

  const [prodd, setProdd] = useState("");
  const { open, handleCancel, handleOpen } = useModalToggle();
  const [openDrawer, setOpenDrawer] = useState(false);
  const showDrawer = () => {
    setOpenDrawer(true);
  };
  const onClose = () => {
    setOpenDrawer(false);
  };

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };
  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "crop_band/delete_cropband",
        cropId: prodd?.cropId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };
  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        cropPathwayId: pathwayId ?? null,
        cropName: e.target.value == "" ? null : e.target.value,
      })
    );
  };

  const handleEdit = async () => {
    await dispatch(setActiveObj({ key: "cropBand", data: prodd }));
    await navigate("/rob/crop-band-add");
  };
  const handleAdd = async () => {
    await dispatch(setActiveObj({ key: "cropBand", data: {} }));
    await navigate("/rob/crop-band-add");
  };
  const handleView = async () => {
    await showDrawer();
  };
  const handleViewName = async (item) => {
    await setProdd(item);
    await showDrawer();
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg12} alt="svg12" />{" "}
            <span className="whitespace-nowrap">Edit</span>
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={handleOpenDelete}>
          <Link className="flex items-center gap-x-2 actions-text my-2">
            <img src={svg49} alt="svg49" className="w-4 h-4" />
            <span className="whitespace-nowrap">Disable</span>
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div onClick={handleView}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg15} alt="svg15" />{" "}
            <span className="whitespace-nowrap">Project Details</span>
          </Link>
        </div>
      ),
    },
  ];

  const truncateText = (text, maxLength) => {
    if (text?.length > maxLength) {
      return text?.substring(0, maxLength - 3) + "...";
    }
    return text;
  };

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Crop Name",
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.cropName}
          </div>
        );
      },
      sorter: (a, b) => a.cropName.localeCompare(b.cropName),
    },

    {
      title: "Slope",
      dataIndex: "cropGroundSlope",
      sorter: (a, b) => a.cropGroundSlope.localeCompare(b.cropGroundSlope),
    },
    {
      title: "Depth of water",
      dataIndex: "cropMaxWaterDepth",
      sorter: (a, b) => a.cropMaxWaterDepth.localeCompare(b.cropMaxWaterDepth),
    },
    {
      title: "County",
      dataIndex: "countyCode",
      sorter: (a, b) => a.countyCode.localeCompare(b.countyCode),
    },
    {
      title: "Acreage",
      dataIndex: "cropSize",
      sorter: (a, b) => a.cropSize.localeCompare(b.cropSize),
    },
    {
      title: "Crops type (Proposed/Existing)",
      dataIndex: "cropCrops",
      render: (item) => {
        return (
          <>
            <Tooltip title={item}>
              <div className="">{truncateText(item, 35)}</div>
            </Tooltip>
          </>
        );
      },
      sorter: (a, b) => a.cropCrops.localeCompare(b.cropCrops),
    },
    {
      title: "Height of the Bund",
      dataIndex: "cropMaxBandHeight",
      sorter: (a, b) => a.cropMaxBandHeight.localeCompare(b.cropMaxBandHeight),
    },
    {
      title: "Catchment Area",
      dataIndex: "cropCatchmentArea",
      sorter: (a, b) => a.cropCatchmentArea.localeCompare(b.cropCatchmentArea),
    },
    {
      title: "Status",
      dataIndex: "cropStatus",
      render: (item) => {
        const colors = {
          ACTIVE: "#28A745",
          COMPLETED: "#3250FF",
          STALLED: "#F44336",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          {pathwayId ? (
            <button onClick={() => handleViewName(item)}>
              <img src={svg15} alt="svg15" />
            </button>
          ) : (
            <Dropdown
              overlayStyle={{
                width: "250px",
              }}
              trigger={"click"}
              menu={{ items: settingItems }}
              placement="bottom"
            >
              <button onClick={() => setProdd(item)}>
                <img src={svg27} alt="svg27" />
              </button>
            </Dropdown>
          )}
        </>
      ),
    },
  ];

  const onFinish = () => {};

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        cropPathwayId: pathwayId ?? null,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
  }, []);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="lg:min-h-[88vh] flex flex-col">
      {!pathwayId && (
        <BreadCrumb breadcrumbs={[{ title: "Trapezoidal Bund For Crops" }]} />
      )}
      <div
        className={`flex flex-col w-full  flex-1 ${
          !pathwayId && "white_card mt-[1.25rem]"
        } `}
      >
        {!pathwayId ? (
          <div className="flex items-center justify-between  gap-y-4">
            <div className="form-add-h">Trapezoidal Bund For Crops</div>
            <div className="w-[200px]">
              <button onClick={() => handleAdd()} className="cstm-btn-2">
                <img src={svg29} alt="svg29" />
                <span className="">Register New</span>
              </button>
            </div>
          </div>
        ) : null}

        <div
          className={`lg:w-[29.1875rem] w-full ${
            !pathwayId && "mt-[3.81rem]"
          } `}
        >
          <Search
            searchInput={searchInput}
            handleSearch={handleSearch}
            text={"Search"}
          />
        </div>

        <div className="max-w-full w-full overflow-x-auto">
          <Table
            rowSelection={false}
            className="mt-[1.75rem] w-full"
            scroll={{
              x: 'max-content',
            }}
            rowKey={(record) => record?.cropId}
            columns={columns}
            dataSource={data}
            loading={loading}
            pagination={{
              position: ["bottomRight"],
              current: pageIndex + 1,
              total: count,
              pageSize: pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                fetchTableData(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
          />
        </div>
      </div>
      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />

      <CropBandView onClose={onClose} open={openDrawer} prodd={prodd} />
    </div>
  );
}

export default CropBandTable;
